import React from 'react';
import { Card, Row, Col, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function QIRAttachment({ qir, onChange }) {
    const { t } = useTranslation();

    return (
        <Card className="mb-2">
            <Card.Header>{t('QIRDetail.Sections.Attachment')}</Card.Header>
            <Card.Body>
                <Row>
                    <Form.Group as={Row} className="mb-1" controlId="attachment">
                        <Form.Label column sm={2}>{t('QIRDetail.Fields.Link')}</Form.Label>
                        <Col sm={10}>
                            <Form.Control type="text" size="sm" value={qir.attachment && qir.attachment} name="attachment" onChange={onChange} />
                        </Col>
                    </Form.Group>
                </Row>
            </Card.Body>
        </Card>
    );
}

export default QIRAttachment;